/* -------------------------------------------------------------------------

	PUNITED.common

	サイト内で共通のスクリプトを定義
	※jQuery必須
	Potential United inc.

------------------------------------------------------------------------- */

// グローバル名前空間定義
var PUNITED;
if (!PUNITED) PUNITED = {};
if (!PUNITED.common) PUNITED.common = {};

(function ($){
	// グローバル名前空間オブジェクトをローカルオブジェクトに置き換え
	var ns = PUNITED.common;

    // 定数
	ns.MEDIA_QUERY_PORTRAIT = 'screen and (orientation: portrait)';
    ns.MEDIA_QUERY_MAX_SP = 'screen and (max-width: 767px)';
	ns.MEDIA_QUERY_MAX_TABLET = 'screen and (min-width: 768px) and (max-width: 1280px)'; // スマホ横から対応
	//ns.MEDIA_QUERY_SP_LANDSCAPE = 'screen and (max-width: 1280px) and (orientation: landscape)'; // スマホ横から対応
    //ns.MEDIA_QUERY_MAX_TABLET = 'screen and (min-width: 1024px) and (max-width: 1280px)'; // タブレット縦から対応
    ns.VIEWPORT_TABLET = '1280';
    ns.EXPAND = 'expand';
    ns.CURRENT = 'current';
    ns.INVISIBLE = 'invisible';
    ns.slideshow;

    
    /* -----------------------------------------------------
        デバイスがモバイルか判定
	----------------------------------------------------- */
    ns.setDeviceMobile = function(){
        $('body').removeClass('device-mobile');
        if(ns.isDeviceMobile()){
            $('body').addClass('device-mobile');
        }
    }
    
    ns.isDeviceMobile = function(){
        var result = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        return result;
    }
    
    ns.isDevice_iPhone_mobile = function(){
        var ua = navigator.userAgent;
        var result = (/iPhone|iPod/i.test(navigator.userAgent)) || (ua.indexOf('Android') > -1 && ua.indexOf('Mobile') > -1);
        return result;            
    }
    
    ns.isDevice_IE = function(){
        var result = (/Trident/i.test(navigator.userAgent));
        return result;            
    }

    
    
    
	/* -----------------------------------------------------
        スマホサイズ判定
	----------------------------------------------------- */
    ns.isMatchMediaSP = function(){
        var result = window.matchMedia(ns.MEDIA_QUERY_MAX_SP).matches;
        return result;
    }
    
    /* -----------------------------------------------------
        タブレットサイズ判定
	----------------------------------------------------- */
    ns.isMatchMediaTablet = function(){
		var result = window.matchMedia(ns.MEDIA_QUERY_MAX_TABLET).matches;
        return result;
    }
	
	/* -----------------------------------------------------
        ポートレイト判定
	----------------------------------------------------- */
    ns.isMatchMediaPortrait = function(){
		var result = window.matchMedia(ns.MEDIA_QUERY_PORTRAIT).matches;
        return result;
    }
	
	/* -----------------------------------------------------
        スマホ ランドスケープ判定
	----------------------------------------------------- */
    /*
	ns.isMatchMediaSPLandscape = function(){
		var result = window.matchMedia(ns.MEDIA_QUERY_SP_LANDSCAPE).matches;
        return result;
    }
	*/
	
	
    
    /* -----------------------------------------------------
        スマホ viewport
	----------------------------------------------------- */
    /*
    ns.setViewportForSP = function(){
        var _viewport;
        if(ns.isMatchMediaSP() && !$('body').hasClass('home')){
            _viewport = $('meta[name="viewport"]');
            _viewport.attr("content", "width=device-width, initial-scale=1");
        }
    }
    */

    /* -----------------------------------------------------
        ビュー高さにあわせる
	----------------------------------------------------- */
    ns.setViewHeight = function(class_name){
        var inner_height = window.innerHeight;
        $(class_name).height(inner_height);

    }
    
    /* -----------------------------------------------------
        タブレット viewport 固定
	----------------------------------------------------- */
    ns.setViewportForTablet = function(){
        var _viewport;
        if(ns.isMatchMediaTablet() && !ns.isDevice_iPhone_mobile() && !$('body').hasClass('home')){
            _viewport = $('meta[name="viewport"]');
            _viewport.attr("content", "width=" + ns.VIEWPORT_TABLET);
        }else{
            // タブレット以外
            _viewport = $('meta[name="viewport"]');
            _viewport.attr("content", "width=device-width, initial-scale=1");
        }
    }
	
    /* -----------------------------------------------------
        PC ローカルナビ設定
	----------------------------------------------------- */
    ns.wrapperMain = '.wrapper-main';
    ns.navGlobal = '.header-global';
    ns.navLocal = '.nav-local';
    ns.fixedMin = 'fixed-min';
    ns.windowTop = 0;
    
    ns.initPCNav = function(){
        if($('body').hasClass('general'))
            return false;
        
        $(window).scroll(function(event){
            if(ns.isMatchMediaSP()) return true;
            if($('body').hasClass('home')) return true;

            var _top = $(this).scrollTop();
            if (_top > ns.windowTop) {
                // 下スクロール
                if(!$(ns.navLocal).hasClass(ns.fixedMin)){
                    $(ns.navGlobal).removeClass(PUNITED.common.EXPAND);
                    $(ns.navLocal).addClass(ns.fixedMin);
                    $(ns.wrapperMain).addClass(ns.fixedMin);
                }
            } else {
                // 上スクロール
                if($(ns.navLocal).hasClass(ns.fixedMin)){
                    if(!$(ns.navLocal).hasClass(ns.fixedMin))
                        return false;
                    
                    $(ns.navLocal).removeClass(ns.fixedMin);
                    $(ns.wrapperMain).removeClass(ns.fixedMin);
                    $(ns.navGlobal).addClass(PUNITED.common.EXPAND);
                }
            }
            ns.windowTop = _top;
        });
    }
    
    /* -----------------------------------------------------
        スマホナビ設定
	----------------------------------------------------- */
    ns.gnavSP = '#gnav-sp';
    ns.navSP = '.nav-sp';
    ns.iconMenuBars = '.icon-menu-bars';
    ns.initSPNav = function(){
		
		$(ns.iconMenuBars).on('click', function(){
			if(!$(this).hasClass(ns.EXPAND)){
				$(this).addClass(ns.EXPAND);
				$(ns.navSP).addClass(ns.EXPAND);
			}else{
				$(this).removeClass(ns.EXPAND);
				$(ns.navSP).removeClass(ns.EXPAND);
			}

			return true;
		});
		
    }
    
    ns.resetSPNav = function(){
		if($(ns.iconMenuBars).hasClass(ns.EXPAND)){
			UIkit.toggle(ns.iconMenuBars).toggle();
			$(ns.iconMenuBars).removeClass(ns.EXPAND);
			$(ns.navSP).removeClass(ns.EXPAND);
		}
    }
    
    /* -----------------------------------------------------
        アンカー移動
	----------------------------------------------------- */
    ns.gotoAnchor = function(element) {
        // Lazyloadの読み込み待ち
        setTimeout(function(){
            // ヘッダ固定無し: 0 ヘッダ固定有り: パディング
            var paddingTop = $('.wrapper-page').css('padding-top');
            paddingTop = parseInt(paddingTop, 10);
            var margin = 30;
            var offset = paddingTop + margin; 
    
            var href= $(element).attr("href");
            if(!href) return false;        
       
            var target = $(href == "#" || href == "" ? 'html' : href);
            var pos = target.offset();
            
            if(pos){           
                var top = pos.top - offset;
                $("html, body").animate({scrollTop:top}, 500, 'swing');
            }
        },1000);      
       
        return true;
    }
    
    /* -----------------------------------------------------
        検索フォーム
	----------------------------------------------------- */
    ns.searchForm = '.search__form';
    ns.searchFormButton = '.search-submit';
    ns.searchFormInput = '.search__form__input';
    ns.searchFormTarget = '.search__form__target';
    ns.searchFormRadio = '.search__form__target input[name="targetBrand"]';
    
    ns.initSearchForm = function(){
        // ラベルクリック
        $(ns.searchFormTarget).children('label').on('click', function(event){
            event.preventDefault();
            var $radio = $(this).prev();
            $(ns.searchFormTarget).children('input[type="radio"]').not($radio).prop('checked', false);
            
            $radio.prop('checked', true);
            var target_path = $radio.data('target');
            if(target_path.length){
                $(this).parents('form').attr('action', target_path);
            }
            
            return false;
        });
        
        
        // 検索ボタン
        $(ns.searchFormButton).on('click', function(){
            if(!$(this).parents(ns.searchForm).hasClass(ns.EXPAND)){
                $(this).parents(ns.searchForm).addClass(ns.EXPAND);
            }else{
                // PCフォームのボタンクリックで検索実行
                $(this).parent('form').submit();
                return false;
            }
            
            // SP
            if($('.gnav-sp').hasClass('uk-open')){
                $(this).parent('form').submit();
                return false;
            }
            
            $(this).next(ns.searchFormInput).focus();
            return true;
        });
        
        
        // 送信値チェック
        $('form.search-form').submit(function(){
            var input_word = $(this).find('.search__form__input').val();
            if(!input_word.length){
                return false;
            }
            
            return true;
        });
        

        // 入力欄
        $(ns.searchForm).find('input,button,a,label').each(function(index,element){
            $(element).on('click',function(event){
                event.stopPropagation();
            });
        });
       
        $('body').on('click', function(){
            $(ns.searchForm).removeClass(ns.EXPAND); 
            return true;
        });
        
        return true;
    }
    
    
    /* -----------------------------------------------------
        スクロール設定
	----------------------------------------------------- */
    ns.scrollbarWidth = 0;
    ns.initScroll = function(){
        ns.scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        ns.setHeaderNavScroll();
        
        /*
        $(window).scroll(function(){
            $('.uk-navbar-dropdown').hide();
            ns.setHeaderNavScroll();
        });
        */

        return true;
    }
    
    // Fixedナビのスクロール
    ns.setHeaderNavScroll = function(){
        // モバイルはヘッダスクロール不要
        if(ns.isDeviceMobile()){
            return true;
        }
        
        var left = $(window).scrollLeft();
        if(ns.scrollbarWidth < left){
            $('.header-global,.nav-local').css('left', -left);
        }else{
            $('.header-global,.nav-local').css('left', 0);
        }
        
        return true;
    }
    
    /* -----------------------------------------------------
        Slick スライドショー：共通メイン
	----------------------------------------------------- */
    ns.slideshowSlick = '.slideshow-slick';
    ns.initSlideshowSlick = function(){
        var nav_dots = $(ns.slideshowSlick).data('nav');
        var zoom = $(ns.slideshowSlick).data('zoom');
        var speed_msec = $(ns.slideshowSlick).data('speed');
        speed_msec = speed_msec ? speed_msec : 800;
        
        if(zoom){
            $(ns.slideshowSlick).on('init.slick', function(event, slick){
                slick.$slides.eq(0).addClass('scale'); 
            });

            $(ns.slideshowSlick).on('beforeChange', function(event, slick, currentSlide, nextSlide){
                slick.$slides.eq(nextSlide).addClass('scale'); 
            });

            $(ns.slideshowSlick).on('afterChange', function(event, slick, currentSlide){
                var slide_num = slick.$slides.length;
                var prev_slide = currentSlide - 1;
                prev_slide = prev_slide < 0 ? slide_num - 1 : prev_slide;
                slick.$slides.eq(prev_slide).removeClass('scale');
            });
        }
        
        $(ns.slideshowSlick).not('.slick-initialized').slick({
            dots: nav_dots,
            appendDots: '.slideshow-nav',
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            infinite: true,
            pauseOnHover: false,
            fade: true,
            speed: speed_msec,
            arrows: false
        });
    }
    
    /* -----------------------------------------------------
        Slick バナースライダー：共通
	----------------------------------------------------- */
    ns.slickSliderBannerResponsive = function(){
        if(!$('.banner-link-slider-sp').length) return true;

        // スライダー
        if(ns.isMatchMediaSP()){
            $('.banner-link-slider-sp').not('.slick-initialized').each(function(index, element){
                $(element).slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                    infinite: true,
                    autoplaySpeed: 2000,
                    centerMode: true,
                    arrows: false,
                    dots: true,
                    appendDots: $(element).siblings('.slide-banner-dots')
                });
            });
        }else{
            $('.banner-link-slider-sp.slick-initialized').slick('unslick');
        }
    }
        
    
    /* -----------------------------------------------------
        Slick スライダー  RELATED CONTENTS
	----------------------------------------------------- */
    ns.slickSliderResponsive = function(){
        if(!$('.related-slick').length) return true;
                
        // スライダー
        if(ns.isMatchMediaSP()){
            $('.related-slick.slick-initialized').slick('unslick');
        }else{
            $('.related-slick').each(function(index, element){
                var slide_num = $(element).data('slidernum');
                slide_num = slide_num > 0 ? slide_num : 3;
                
                
                if($(element).children().length <= slide_num){
                    $(element).addClass('slick-none');
                    return true;
                }
                
                $(element).not('.slick-initialized').slick({
                    slidesToShow: slide_num,
                    slidesToScroll: 1,
                    autoplay: true,
                    infinite: true,
                    autoplaySpeed: 2000,
                    prevArrow: '<button type="button" class="slick-prev icon-arrow icon-arrow-left"></button>',
                    nextArrow: '<button type="button" class="slick-next icon-arrow icon-arrow-right"></button>'
                });
            });
        }
    }
    
    /* -----------------------------------------------------
        Slick スライダー  製品画像
	----------------------------------------------------- */
    ns.slickMainPhoto = '.photo-common-slick';
    ns.slickMainCaption = '.photo-common-caption-slick';
    ns.mainThumbnail = '.product-photos__thumbnail .item';
    
    ns.initSlickMainPhoto = function(){
        if(!$('.photo-common-slick').length) return true;
        
        $(ns.slickMainPhoto).not('.slick-initialized').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            infinite: true,
            pauseOnHover: false,
            fade: false,
            speed: 500,
            prevArrow: '<button type="button" class="slick-prev icon-arrow icon-arrow-left"></button>',
            nextArrow: '<button type="button" class="slick-next icon-arrow icon-arrow-right"></button>'
        });

        $(ns.slickMainCaption).not('.slick-initialized').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            infinite: false,
            arrows: false,
            fade: true,
            speed: 200,
            cssEase: 'linear',
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        adaptiveHeight: true
                    }
                },
            ]
            
        });
        
        
        // サムネイル連動
        $(ns.slickMainPhoto).on('afterChange', function(event, slick, currentSlide){
            $(ns.slickMainCaption).slick('slickGoTo', currentSlide, false);
            $(ns.mainThumbnail).removeClass('current');
            $(ns.mainThumbnail).eq(currentSlide).addClass('current');
            
            return true;
        });
        
        $(ns.mainThumbnail).on('click', function(event){
            event.preventDefault();
            var _slideIndex = $(ns.mainThumbnail).index(this);
            $(ns.mainThumbnail).removeClass('current');
            $(this).addClass('current');
            $(ns.slickMainPhoto).slick('slickGoTo', _slideIndex, false);
            $(ns.slickMainCaption).slick('slickGoTo', _slideIndex, false);
            
            return true;
        });
    }
    
    /* -----------------------------------------------------
        旧投稿のYoutube埋め込みなどをラップ：スマホ横幅対応
	----------------------------------------------------- */
    ns.setYoutubeWrapper = function(){
        $('.page-contents-main iframe').each(function(index, element){
			if($(element).parent('.iframe-wrapper').length || $(element).hasClass('wrapper-none')) return false;
            var _src = $(element).attr('src');
            var _classAdd = '';
            switch(true){
                case _src.indexOf('youtube') >= 0:
                    _classAdd = 'video';
                    break;
                default: 
                    _classAdd = '';
                    break;
            }
			
			
            $(element).wrap('<div class="iframe-wrapper '+ _classAdd +'"></div>');
        });
        
        return true;
    }
    
    // Fixed ロゴのスクロール
    /* -----------------------------------------------------
        スクロール設定
	----------------------------------------------------- */
    ns.scrollbarWidth = 0;
    ns.initBoxScroll = function(){
        ns.scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        ns.setFixedBoxScroll();

        $(window).scroll(function(){
            ns.setFixedBoxScroll();
        });

        return true;
    }

    ns.setFixedBoxScroll = function(){
        var left = $(window).scrollLeft();
        if(ns.scrollbarWidth < left){
            $('.box-fixed').css('left', -left);
        }else{
            $('.box-fixed').css('left', 0);
        }

        return true;
    }
    
    /* -----------------------------------------------------
        YouTube
	----------------------------------------------------- */
    ns.youtubeID;
    ns.player;
    ns.done;
    ns.apiTagElement = false;
    ns.videoIframe = '.video-youtube';
    ns.controls = 0;
    ns.autoplay = 1;
    ns.scaleFitBox = true;
    ns.playLoop = true;
    
    ns.playerReady = false;
    ns.eventVideoLoaded = 'loaded';
    ns.eventVideoEnded = 'ended';
    
    ns.iframeWrapperVideo = '.iframe-wrapper.video';
    ns.videoCover = '.video-cover';
    ns.playing = 'playing';
    ns.YOUTUBE_PLAYED = 'yt-played';
    
    
    ns.initYoutube = function(){
        var _wrapper = $('#video-main').data('youtube-wrapper');
        if(_wrapper !== undefined)
            ns.videoIframe = _wrapper;
        
        ns.youtubeID = $('#video-main').data('youtube-id');
        var _autoplay = $('#video-main').data('autoplay');
        if(_autoplay !== undefined)
            ns.autoplay = _autoplay;

        // load YouTube API
        if(ns.apiTagElement.length){
            ns.restartVideo();
        }else{
            ns.setYoutubeAPI();
        }
    }
	
	ns.setYoutubeAPI = function(){
		var tag = document.createElement('script');
		tag.src = "https://www.youtube.com/iframe_api";
		var firstScriptTag = document.getElementsByTagName('script')[0];
		ns.apiTagElement = firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
	
    ns.singlePlayers = {};

    ns.loadAllYoutube = function(){
        // ページメインのビデオ、iframe埋め込みの単体ビデオのロード
        PUNITED.common.loadYoutubeVideos();

        // CiAN ビデオ
        if(PUNITED.cian)
            PUNITED.cian.initYTIframe();

        // BASS Hook ビデオ
        if(PUNITED.hook)
            PUNITED.hook.initYTIframe();
    }
	
	ns.loadYoutubeVideos = function(){
		var _protocol = location.protocol;
		var _slashes = _protocol.concat("//");
		var _host = _slashes.concat(window.location.hostname);
		var _playList = ns.playLoop ? ns.youtubeID : '';

        // モバイルのメインは各ページのスクリプトに記述：同時再生不可に対応
        if(ns.setDeviceMobile() && !ns.isMatchMediaTablet()){
           return;
        }
		
		// ページメインのビデオ
		ns.player = new YT.Player('video-main', {
			width: '140%',
			height: '140%',
			videoId: ns.youtubeID,
			listType: 'playlist',
			playerVars: {
				showinfo: 0,
				modestbranding: 1,
				autohide: 1,
				autoplay: ns.autoplay,
				controls: ns.controls,
				showsearch: 0,
				rel: 0,
				enablejsapi: 1,
				wmode: 'transparent',
				playlist: _playList,
				origin: location.protocol + '//' + location.hostname + "/"
			},
			events: {
				'onReady': ns.onPlayerReady,
				'onStateChange': ns.onPlayerStateChange,
				'onError': ns.onPlayerError
			}
		});
		
		
		// iframe埋め込みの単体ビデオ  ※クラス single-video以下に配置。idとURLパラメーター「enablejsapi=1」必須
        $(".single-video iframe[id]").each(function () {
            
            var frameID = this.id;
			if(frameID){
				ns.singlePlayers[frameID] = new YT.Player(frameID, {
					playerVars: {
						autoplay: 0,
						controls: 0,
						showsearch: 0,
						rel: 0,
						enablejsapi: 1,
                        wmode: 'transparent',
					},
					events: {
						'onReady': ns.onPlayerReadySingle,
						'onStateChange': ns.onPlayerStateChangeSingle,
					}
				});
			}
		});
	}
	
	
    ns.isReady = function(){
        return ns.playerReady;
    }

    ns.onPlayerError = function(event) {
        $('body').addClass('yt-error');
    }
    
    ns.onPlayerReady = function(event) {
		if(typeof(ns.player) == 'undefined' && $('#video-main').length){
			ns.loadYoutubeVideos();
			return false;
		}
		
		if(typeof(ns.player) == 'undefined' || 0 === $('#video-main').length){
			return false;
		}

        // ロード完了イベント発火
        ns.playerReady = true;
        $(ns.videoIframe).trigger(ns.eventVideoLoaded);
        
        ns.player.setVolume(0);
        ns.player.mute();
        if(ns.playLoop)
            ns.player.setLoop(true);   // playlistをループ再生
        
        // 自動再生
        if ("1" == ns.autoplay && $('#video-main').is(':visible')) {
            ns.player.playVideo();
        }
    }
    
    ns.onPlayerStateChange = function(event) {
        switch (event.data) {
            case YT.PlayerState.ENDED:
                // ループ再生
                if(ns.playLoop)
                    ns.restartVideo();
                
                // 終了イベント発火
                $(ns.videoIframe).trigger(ns.eventVideoEnded);
                
                break;
            case YT.PlayerState.PLAYING:
                // スタート時：ポスター画像非表示
                // 縦横設定
				ns.player.setVolume(0);
				ns.player.mute();
                ns.videoScaleFitBox();
                if("1" == ns.autoplay)
                    $(ns.videoIframe).animate({ 'opacity': 1 }, 1000);
                
                $('body').addClass(ns.YOUTUBE_PLAYED);
                break;
            case YT.PlayerState.PAUSED:
                break;
            case YT.PlayerState.BUFFERING:
                break;
            case YT.PlayerState.CUED:   // 頭出し完了
                break;
            case -1: // 未スタート                
                break;
            default:
                break;
        }        
    }


    ns.restartVideo = function() {
        if(typeof ns.player.setLoop != 'function'){
            return false;
        }

		ns.player.setVolume(0);
		ns.player.mute();
        ns.player.seekTo(0);
        ns.player.setLoop(true);
    }
    
    ns.playVideoOnce = function() {
        if(typeof ns.player.setLoop != 'function'){
            return false;
        }

		ns.player.setVolume(0);
		ns.player.mute();
        ns.player.seekTo(0);
        ns.player.setLoop(false);
        ns.player.playVideo();
    }
    

    ns.stopVideo = function() {
        if(typeof ns.player.stopVideo != 'function'){
            return false;
        }

        ns.player.stopVideo();
    }
    
    // 単体ビデオのイベント
    ns.onPlayerReadySingle = function (event) {

        // 単体ビデオのカバー画像クリックで再生
        $(ns.videoCover).click(function(){
            $(this).fadeOut();
            var frameID = $(this).siblings('iframe').attr('id');

            if(ns.singlePlayers[frameID]){
                ns.singlePlayers[frameID].playVideo();
            }
        });
    }

    ns.onPlayerStateChangeSingle = function(event) {

        // 終了時にカバーイメージを表示するイベントを設定
        switch (event.data) {
            case YT.PlayerState.ENDED:
                // 終了
                $(event.target.a).siblings(ns.videoCover).fadeIn();

                break;
            case YT.PlayerState.PLAYING:
                // スタート時：ポスター画像非表示
                $(event.target.a).siblings(ns.videoCover).fadeOut();
                
                break;
            case YT.PlayerState.PAUSED:
                //console.log('paused ' + frameID);
                break;
            case YT.PlayerState.BUFFERING:
                break;
            case YT.PlayerState.CUED:   // 頭出し完了
                break;
            case -1: // 未スタート                
                break;
            default:
                break;
        }    
    }

    

    // ビデオサイズ変更
    ns.videoView = '.home-main';
    ns.videoScaleFitBox = function() {
        if(!ns.scaleFitBox)
            return true;
   
        
        var video = '#video-main';
        
        var video_zoom = $(video).data('zoom');
        video_zoom = video_zoom !== undefined ? video_zoom : 1;
        var class_parent_box = $(video).data('parent-box');
        if(class_parent_box !== undefined)
            ns.videoView = class_parent_box;
        
        // Youtube 16:9
        var video_ratio_landscape = 0.5625;
        var video_ratio_portrait = 1.778;

        var view_height = $(ns.videoView).height();
        var view_width = $(ns.videoView).width();
        var view_ratio = view_height / view_width;
       
        if(view_ratio > video_ratio_landscape){
            video_new_height = view_height;
            video_new_width = view_height * video_ratio_portrait;
        }else{
            video_new_width = view_width;
            video_new_height = view_width * video_ratio_landscape;
        }

        $(video).height(video_new_height * video_zoom).width(video_new_width * video_zoom);
    }
    
    
    
    /* -----------------------------------------------------
        問い合わせフォーム
	----------------------------------------------------- */
    ns.initContactForm = function(){
        
        
        // キャンペーン選択
        var additional = '【商品名】\n【購入店舗】\n【購入日】\n';
        var $__textarea_message = $('textarea[name="jcl-message"]');
        var class__campaign = '.message-campaign';

        var destination = $('select[name="jcl-destination"]').val();
        var is_campaign = destination.length && -1 < destination.indexOf('キャンペーン');
        
        // 改行なし文字列で比較
        var text_template = additional.replace("/\n/", '');
        var text_message = $__textarea_message.val().replace("/\r\n|\r|\n/", '');
        
        var include_cappaign_template = text_message.match(/【商品名】|【購入店舗】|【購入日】/);
       
        if(is_campaign){
            $(class__campaign).removeClass(ns.INVISIBLE);
            
            // キャンペーン再選択時に雛形ない場合は追加
            if(text_message.length && null === include_cappaign_template){
                $__textarea_message.val(text_message + "\n\n" + additional);
            }else if(0 === text_message.length){
                $__textarea_message.val(additional);
            }
           
            
        }else{
            $(class__campaign).addClass(ns.INVISIBLE);
            
            // キャンペーン以外選択された場合は、雛形のみは削除
            if(text_template == text_message){
                $__textarea_message.val('');
            }
        }
        
    }
    
    
    /* -----------------------------------------------------
        Slick Instagramスライダー
	----------------------------------------------------- */
    ns.slickSliderInstagramResponsive = function(){
        // スライダー
        if(!PUNITED.common.isMatchMediaSP()){
            $('.slider-instagram').not('.slick-initialized').slick({
                dots: false,
                slidesToShow: 5,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 0,
                infinite: true,
                pauseOnHover: false,
                fade: false,
                cssEase: 'linear',
                speed: 5400,
                arrows: false
            });
        }else{
            $('.slider-instagram.slick-initialized').slick('unslick');
        }
    }

	ns.setSendErrorPage = function(){
		var _class_error = '.mw_wp_form_send_error';
		var _class_message = '.msg-thanks';

		if( $(_class_error).length ){
			$(_class_message).hide();
		}
	}

    ns.specTitleLinkAccordion = function(){
        $('.product-spec a[href]').on('click', function(event) {
            var link = $(this).attr('href');

            // 全てのアコーディオンを閉じる
            $('.product-lineup .uk-accordion').each(function(index, element){
                if( $(element).find('.accordion-state').hasClass('uk-open') ){
                    UIkit.accordion($(element)).toggle(0);
                }
            });

            // リンク先を開く
            UIkit.accordion($(link)).toggle(0);
        });
 
    }

    // 製品COLOR CHART 注釈／JANコードコピー対応
    ns.colorClickCaption = function(event){
        event.stopPropagation();
        event.stopImmediatePropagation();
        const text_jan_code = $(event.target).parents('.fancybox-content').find('.fancybox-custom-caption').text();
        ns.copyCaption(text_jan_code);
    }

    ns.copyCaption = function(text_jan_code){
        if(0 === text_jan_code.length){
            return;
        }

        // ボタンタイトルの「テキストをコピー」を削除
        text_jan_code = text_jan_code.replace('テキストをコピー', '');
        navigator.clipboard.writeText(text_jan_code);
        ns.copyCaptionMessage();
    }

    ns.copyCaptionMessage = function(){
         UIkit.notification({
            message: 'テキストをコピーしました。',
            status: 'primary',
            pos: 'top-right',
            timeout: 1000
        });
    }

    // 製品のCOLOR CHART ケイムラ対応 Swiper
    ns.swiperNavThumbnail = null;
    ns.swiperMain = null;
    ns.initProductColorSwiper = function(instance, current){

        if( ns.swiperNavThumbnail ) {
            ns.swiperMain = null;
            ns.swiperNavThumbnail = null;
        }

        if( 0 === $(current.$content).find('.swiper-nav-thumbnail').length ){
            return;
        }   

       ns.swiperNavThumbnail = new Swiper( $(current.$content).find('.swiper-nav-thumbnail'), {
            loop: false,                    
            spaceBetween: 0,
            slidesPerView: 4,
            // freeMode: true,
        });

        ns.swiperMain = new Swiper(".fancybox-slide .swiper-main", {
            loop: true,
            slidesPerView: 1,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            spaceBetween: 0,
            thumbs: {
                swiper: ns.swiperNavThumbnail,
                multipleActiveThumbs: false,
            },
        });
    }

    
	/* -----------------------------------------------------
        document ready
	----------------------------------------------------- */
    $(document).ready(function(){

        if(PUNITED.common.isMatchMediaSP()){
            $('html,body').animate({ scrollTop: 1 }, '1');
        }

        // タブレット判定
        PUNITED.common.setDeviceMobile();



        // 製品詳細 RODスペックのアコーディオン
        PUNITED.common.specTitleLinkAccordion();
        
        
        // 検索フォーム設定
        PUNITED.common.initSearchForm();

        // トップメインのスライドショー
        PUNITED.common.initSlideshowSlick();

        // タブレットはviewport固定
        PUNITED.common.setViewportForTablet();
        window.matchMedia(PUNITED.common.MEDIA_QUERY_MAX_TABLET).addListener(function(){
            PUNITED.common.setViewportForTablet();
        });

        // スクロール設定
        PUNITED.common.initScroll();
        

        // ブログ内のYoutube ラップ
        PUNITED.common.setYoutubeWrapper();


        // スマホでスライダー非表示
        var matchSP = window.matchMedia(PUNITED.common.MEDIA_QUERY_MAX_SP);
        matchSP.addListener(PUNITED.common.slickSliderResponsive);
        PUNITED.common.slickSliderResponsive();

        // トップ共通バナーリンクスライダー
        matchSP.addListener(PUNITED.common.slickSliderBannerResponsive);
        PUNITED.common.slickSliderBannerResponsive();

        // Instagram スライドショー ※スマホでスライダー非表示 RGM, Revolatege
        var matchSP = window.matchMedia(PUNITED.common.MEDIA_QUERY_MAX_SP);
        matchSP.addListener(PUNITED.common.slickSliderInstagramResponsive);
        PUNITED.common.slickSliderInstagramResponsive();

        // 製品写真
        PUNITED.common.initSlickMainPhoto();

        // 製品 COLOR CHART スマホのJANコードコピー
        $('.product-color-list .caption__sp.note-jan').on('click', function(event){
            var text_jan_code = $(event.target).parents('.note-jan').text();
            navigator.clipboard.writeText(text_jan_code);

            PUNITED.common.copyCaptionMessage();
        });

        // fancybox
         $('[data-fancybox="product-colors"]').fancybox({
            smallBtn: true,
            toolbar: false,
            infobar: false,
            arrows: true,
            loop: true,
            transitionEffect: "slide",
            transitionDuration: 800,
            clickOutside: "close",
            hash: false,
            // clickContent: true, //"next",
            clickContent : function(current, event) {
                return false;
            },
            mobile: {
                clickContent: function(current, event) {
                    return false;
                },
            },
            afterLoad: function(instance, current){
                if( $(current.$content).find('.fancybox-custom-caption').length ){
                    return true;
                }
               
                var old_class = $('article').hasClass('old-post') ? ' old-post-color' : '';
                $('.fancybox-content').addClass(old_class);
                $('.fancybox-close-small').addClass(old_class);
                if ( instance.group.length > 1 && current.$content ) {
                    current.$content.append('<div class="fancybox-custom-caption">' + current.opts.caption + '</div>');
                    current.$content.find('.fancybox-custom-caption').append('<button type="button" class="button-copy-text-color button-common brand-color-text-border-hover">テキストをコピー</button>');
                    current.$content.children('.fancybox-image').map(function(index, element){
                        if(!$(element).closest('.fancybox-image-wrapper').length){
                            $(element).wrap('<div class="fancybox-image-wrapper' + old_class + '"></div>');
                        }
                    });
                }

                var window_width = $(window).width();
                var large_w = 800 <= window_width;
                var small_w = window_width * .8;
                current.width = large_w ? 800 : small_w;
               
                if( old_class.length ){
                    current.height = large_w ? 533 : small_w * .66625;
                }else{
                    current.height = 'auto';
                }
                
            },
            afterShow: function(instance, current){                
                PUNITED.common.initProductColorSwiper(instance, current);
                
                // キャプションクリック
                var clickEvent = document.ontouchstart !== null ? 'click' : 'touchstart';
                current.$content.get(0).querySelector('.fancybox-custom-caption').addEventListener(clickEvent, PUNITED.common.colorClickCaption, true);
                current.$content.get(0).querySelector('.button-copy-text-color').addEventListener(clickEvent, PUNITED.common.colorClickCaption, true);
            }
        });       
        
        // IE以外はウィンドウオープン時に自動再生 ※仕様変更により自動再生方法を変更する必要あり。現在未使用（Revoltage）
        if(!PUNITED.common.isDevice_IE()){
            $('.modal-movie').each(function(index, element){
                var src = $(element).find('iframe').prop('src');
                if(undefined !== src){
                   // $(element).find('iframe').prop('src', src + '?autoplay=1');
                }
            });
        }

        // スマホナビ
        PUNITED.common.initSPNav();

        // PCローカルナビ
        PUNITED.common.initPCNav();

        // input ファイル選択
        if($('.form-contact').length){
            // エラー表示画面
            var form_data = $('.form-contact form').serializeArray();
            var file_path = '';
            $.each(form_data, function(index, element){
                if('jcl-image' == element.name){
                    file_path = element.value;
                }
            });
            if(file_path.length && !$('.mw_wp_form_confirm').length){
                $('.file-select .file-name').html('');
                $('.file-select').addClass('select-preview')
            }
            
            
            $('input[type=file]').on('change', function(){
                var file_name = $(this)[0].files[0] ? $(this)[0].files[0].name : '';
                if(file_name.length){
                    $('.file-select .file-name').html(file_name);
                    $('.file-select').addClass('select')
                }
            });

            $('.file-select .delete').on('click', function(){
                $('input[type=file]').val('');
                $('.file-select .file-name').html('');
                $('.mw-wp-form_image').remove();
                $('.file-select').removeClass('select select-preview');
            });
            
            // キャンペーン選択
            PUNITED.common.initContactForm();
            $('select[name="jcl-destination"]').change(function(element){
                PUNITED.common.initContactForm();
            });
            
        }
        
		
		window.addEventListener( 'resize', function() {
			// リサイズでリセットするもの
            PUNITED.common.setDeviceMobile();
			if(!PUNITED.common.isMatchMediaSP()){
				PUNITED.common.resetSPNav();
				PUNITED.common.setYoutubeWrapper();
			}
			// PC版で動画の自動再生
			PUNITED.common.onPlayerReady();


			$.fancybox.close();
		});
		
		// 問い合わせエラーページ
		PUNITED.common.setSendErrorPage();


        // ページ内リンク移動    
        $("a[href ^= '#']").click(function(){
             PUNITED.common.gotoAnchor(this);
        });
		
		
		// 製品詳細v2 
		if($('.layout-product-v2').length){
			$('.iframe-wrapper .cover-hover-stop').hover(
				function() {
					event.preventDefault();
					event.stopPropagation();
					
					return false;
				},
				function() {

				}
			);
		}

        // 製品詳細 インプレッション→レビュー欄のview-more
        $('.view-more').on('click', function(event){
            event.preventDefault();
            var _target = $(this).siblings('.view-more-target');
            $(_target).toggleClass('expand');

            if( $(_target).hasClass('expand') ){
                $(this).html('<span class="title">閉じる</span><span uk-icon="icon: chevron-up;"></span>');
            }else {
                $(this).html('<span class="title">もっと見る</span><span uk-icon="icon: chevron-down;"></span>');
            }
        });
			

    });
   
})(jQuery);



window.onYouTubeIframeAPIReady = function() {
    // ページメインのビデオ、iframe埋め込みの単体ビデオのロード
    PUNITED.common.loadYoutubeVideos();

    // CiAN ビデオ
    if(PUNITED.cian)
        PUNITED.cian.initYTIframe();

    // BASS Hook ビデオ
    if(PUNITED.hook)
        PUNITED.hook.initYTIframe();

    return true;
}
